import React, { useState, useEffect } from "react";
import styles from "./Contact.module.css";
import { ContactService } from "../../services/contact_service";
import { SettingService } from "../../services/setting_service";
import Notification from "../Notification/Notification";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import { AiOutlineLoading } from "react-icons/ai";
import contact from "./contact_img.jpg"
const Contact = () => {
  const contactService = ContactService();
  const settingService = SettingService();
  const [contactList, setContactList] = useState([]);
  const [settingData, setSettingData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    message: "",
  });

  // Notification state
  const [notification, setNotification] = useState({
    show: false,
    type: "success",
    title: "",
    message: ""
  });

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchSettingData = async () => {
      try {
        await settingService.fetchAllSetting(setSettingData);
      } catch (error) {
        console.error("Error fetching data", error);
        setNotification({
          show: true,
          type: "error",
          title: "Data Load Error",
          message: "Failed to load contact information. Please try again later."
        });
      } finally {
        setLoading(false);
      }
    };
    fetchSettingData();
  }, []);

  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification(prev => ({ ...prev, show: false }));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  const mandatoryFields = ["name", "email", "contact", "message"];
  const contactInfo = settingData.length > 0 ? settingData[0] : null;

  const validateForm = () => {
    const newErrors = {};
    mandatoryFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field
          .replaceAll("_", " ")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")} is required.`;
      }
    });

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (formData.contact) {
      if (formData.contact.length < 10) {
        newErrors.contact = "Contact number should be at least 10 digits.";
      }
      // Additional check for non-numeric characters (just in case)
      if (!/^\d+$/.test(formData.contact)) {
        newErrors.contact = "Contact number should contain only digits.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // For contact field, only allow numbers
    if (name === "contact") {
      // Remove any non-digit characters
      const numericValue = value.replace(/\D/g, '');
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!validateForm()) {
      // setNotification({
      //   show: true,
      //   type: "warning",
      //   title: "Validation Error",
      //   message: "Please fill all required fields correctly."
      // });
      return;
    }

    setSubmitting(true);

    try {
      const success = await contactService.createContact(
        formData,
        setContactList,
        setErrors
      );

      setSubmitting(false);

      if (success) {
        setNotification({
          show: true,
          type: "success",
          title: "Message Sent Successfully!",
        });

        setFormData({
          name: "",
          email: "",
          contact: "",
          message: "",
        });
        setErrors({});
      } else {
        setNotification({
          show: true,
          type: "error",
          title: "Sending Failed",
          message: "Failed to send message. Please try again."
        });
      }
    } catch (error) {
      setSubmitting(false);
      setNotification({
        show: true,
        type: "error",
        title: "Error",
        message: "An unexpected error occurred. Please try again."
      });
      console.error("Submit error:", error);
    }
  };

  const handleNotificationClose = () => {
    setNotification(prev => ({ ...prev, show: false }));
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <p>Loading contact detail...</p>
      </div>
    );
  }

  return (
    <div className={styles.contactPage}>
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={handleNotificationClose}
      />

      <div className={styles.header}>
        <h1 className={styles.heading}>Contact Us</h1>
      </div>
      <div className={styles.contactContainer}>
        <div className={styles.contactMapRow}>
          <div className={settingData ? styles.contactInfoSection : styles.noContactInfo}>
            <img src={contact} alt="Contact" height={170} width="100%" />
            {settingData && (settingData.address || settingData.contact_1 || settingData.email) ? (
              <div className={styles.contactDetails}>
                {settingData.address && (

                  <div className={styles.contactItem}>
                    <span className={styles.contactIcon}>
                      <FaMapMarkerAlt />
                    </span>
                    <div className={styles.contactText}>
                      <strong>Address:</strong>
                      <p>{settingData.address}</p>
                    </div>
                  </div>

                )}

                {settingData.contact_1 && (

                  <div className={styles.contactItem}>
                    <span className={styles.contactIcon}>
                      <FaPhone />
                    </span>
                    <div className={styles.contactText}>
                      <strong>Phone:</strong>
                      <p>{settingData.contact_1}</p>
                    </div>
                  </div>

                )}


                {settingData.email && (

                  <div className={styles.contactItem}>
                    <span className={styles.contactIcon}>
                      <FaEnvelope />
                    </span>
                    <div className={styles.contactText}>
                      <strong>Email:</strong>
                      <p>{settingData.email}</p>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.noDataWrapper}>
                <div className={styles.noData}>
                  <div className={styles.noDataIcon}>
                    <FaPhoneAlt />
                  </div>
                  <h3>No Contact Information Found</h3>
                  <p>Contact details will be available soon.</p>
                </div>
              </div>
            )}
          </div>

          <div className={styles.formSection}>
            <form className={styles.form} onSubmit={handleSubmit} noValidate>
              <div className={styles.formGroup}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={handleChange}
                  className={`${styles.input} ${errors.name ? styles.error : ""}`}
                />
                {errors.name && (
                  <span className={styles.errorText}>

                    {errors.name}
                  </span>
                )}
              </div>

              <div className={styles.formGroup}>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email *"
                  value={formData.email}
                  onChange={handleChange}
                  className={`${styles.input} ${errors.email ? styles.error : ""}`}
                />
                {errors.email && (
                  <span className={styles.errorText}>

                    {errors.email}
                  </span>
                )}
              </div>

              <div className={styles.formGroup}>
                <input
                  type="tel"
                  name="contact"
                  placeholder="Your Phone Number *"
                  value={formData.contact}
                  onChange={handleChange}
                  maxLength={10}
                  className={`${styles.input} ${errors.contact ? styles.error : ""}`}
                />
                {errors.contact && (
                  <span className={styles.errorText}>

                    {errors.contact}
                  </span>
                )}
              </div>

              <div className={styles.formGroup}>
                <textarea
                  name="message"
                  placeholder="Your Message *"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  className={`${styles.textarea} ${errors.message ? styles.error : ""}`}
                ></textarea>
                {errors.message && (
                  <span className={styles.errorText}>

                    {errors.message}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className={styles.submitButton}
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <AiOutlineLoading className={styles.submitSpinnerIcon} />
                    Sending...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {settingData.location && (
        <div className={styles.mapSection}>
          <h2 className={styles.sectionTitle} style={{ marginTop: "2rem" }}>
            Find Us Here
          </h2>
          <div className={styles.mapContainer}>
            <iframe
              src={settingData.location}
              height="400px"
              width="100%"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Royal Cricket Team Location"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;